"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Report = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Report = function Report() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.147 1.173l4.68 4.68A4 4 0 0124 8.653v6.667a4 4 0 01-1.147 2.827l-4.68 4.68A4 4 0 0115.347 24H8.68a4 4 0 01-2.827-1.147l-4.68-4.68A4 4 0 010 15.347V8.68a4 4 0 011.173-2.827l4.654-4.68A4 4 0 018.653 0h6.667a4 4 0 012.827 1.173zm2.8 15.08c.246-.248.385-.583.386-.933l.027-6.64a1.333 1.333 0 00-.387-.933L16.28 3.053a1.334 1.334 0 00-.933-.386H8.68c-.35.001-.685.14-.933.386L3.053 7.72a1.333 1.333 0 00-.386.933v6.667c.001.35.14.685.386.933l4.667 4.694c.248.246.584.385.933.386h6.667c.35-.001.685-.14.933-.386l4.694-4.694zm-8.28-1.586h-1.334a.667.667 0 00-.666.666v1.334c0 .368.298.666.666.666h1.334a.667.667 0 00.666-.666v-1.334a.667.667 0 00-.666-.666zm-1.574-8h1.814a.667.667 0 01.666.746l-.533 4.294a.333.333 0 01-.333.293h-1.414a.333.333 0 01-.333-.293l-.533-4.294a.667.667 0 01.666-.746z",
    clipRule: "evenodd"
  });
};

exports.Report = Report;